var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 802.89648,
    height: 637.72839,
    viewBox: "0 0 48.173789 38.263703",
    fill: "none",
    id: "svg10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path5363",
    style: {
      color: "#000000",
      fill: "#ffffff"
    },
    d: "M 24.089883,0 22.826133,2.0077734 0,38.259727 l 20.982305,0.0018 V 35.273086 L 5.4120703,35.271445 24.089883,5.6074219 42.761719,35.27543 22.945664,35.27332 v 2.988282 l 25.228125,0.0021 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5363-6",
    style: {
      color: "#000000",
      fill: "#ffffff"
    },
    d: "m 24.091758,14.070352 -1.257774,1.958906 -10.625039,16.560586 13.02,0.0011 v -2.988165 l -7.553203,-0.0012 6.416016,-9.998086 6.412148,10.000078 -3.311601,-4.69e-4 v 2.988047 l 8.778398,7.03e-4 z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      stroke: "none",
      strokeWidth: 0.06
    },
    id: "rect291",
    width: 2.2835698,
    height: 2.9847488,
    x: 22.945454,
    y: 32.455669
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.707dcb083b53b2138644d11374ccf029.svg";
export { ForwardRef as ReactComponent };